<script>
import {pushECO} from "@/api/forecastManagement/deliveryService";

export default {
  name: "pushECO",
  data() {
    return {
      shipments: '',
      result: [],
      fields: [
        {
          type: 'index',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('B2bOrderNo'),
          key: 'shipmentNumber',
          width: 160,
          align: 'center'
        },
        {
          title: this.$t('planStatus'),
          key: 'status',
        },
      ]
    }
  },
  methods: {
    handleSubmit() {
      if (this.shipments.trim().length === 0) {
        return this.$Message.error(this.$t('enter') + this.$t('B2bOrderNo'))
      }
      this.$Spin.show()
      // 拆分数据
      let allRows = this.shipments.trim().split('\n').map(item => item.trim().toUpperCase())

      this.result = []
      this.sendRequest(allRows, 0, allRows.length)
    },
    sendRequest(pools, index, limit) {
      if (index >= limit) {
        this.$Spin.hide()
        return
      }
      pushECO({
        action: 'pushECO',
        vars: pools[index]
      }).then(res => {
        this.result.push(res.data.payload[0])
        this.sendRequest(pools, index+1, limit)
      }).catch(e => {
        this.$Spin.hide()
        this.$Message.warning(e.msg)
      })
    }
  }
}
</script>

<template>
  <Card style="position:relative; height: 100%;">
    <Row :gutter="24">
      <Col span="8">
        <Form label-position="top">
          <FormItem :label="$t('B2bOrderNo')">
            <Input  v-model="shipments" type="textarea" :rows="10" :placeholder="$t('enter') + $t('B2bOrderNo')"></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="handleSubmit">{{$t('order_submit')}}</Button>
          </FormItem>
        </Form>
      </Col>
      <Col span="16">
        <Table width="90%" border :columns="fields" :data="result"></Table>
      </Col>
    </Row>
  </Card>
</template>

<style scoped>

</style>
